import { render, staticRenderFns } from "./ConfigurationTab.vue?vue&type=template&id=2c35cbb4&scoped=true"
import script from "./ConfigurationTab.vue?vue&type=script&lang=js"
export * from "./ConfigurationTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationTab.vue?vue&type=style&index=0&id=2c35cbb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35cbb4",
  null
  
)

export default component.exports